import { reportsService } from '@/services';
import { downloadBlob } from '@/shared/utils/download-blob.util';
import { useMutation } from '@tanstack/react-query';

interface DownloadBoletoParams {
  /** id_endosso (nativo do i4pro). */
  endorsementId: number;
  /** id_parcela (nativo do i4pro). */
  installmentId: number;
  /** Número da parcela — só para nomear o arquivo. */
  installmentNumber?: number | null;
  /** CNPJ da corretora da linha — a Api barra corretora inativa (403). */
  brokerTaxId?: string | null;
}

/**
 * Baixa a 2ª via do boleto de uma parcela (PDF base64 → blob → download).
 * Espelha o fluxo da tela de apólice (`useInstallmentPdf`).
 */
export function useInstallmentBoleto() {
  return useMutation({
    retry: false,
    mutationFn: async ({
      endorsementId,
      installmentId,
      installmentNumber,
      brokerTaxId,
    }: DownloadBoletoParams) => {
      const result = await reportsService.getInstallmentBoleto(
        endorsementId,
        installmentId,
        brokerTaxId
      );
      if (!result.success || !result.data?.pdfBase64) {
        throw new Error(result.error || 'Boleto ainda não disponível para esta parcela.');
      }

      const byteChars = atob(result.data.pdfBase64);
      const bytes = new Uint8Array(byteChars.length);
      for (let i = 0; i < byteChars.length; i++) {
        bytes[i] = byteChars.charCodeAt(i);
      }
      const blob = new Blob([bytes], { type: 'application/pdf' });
      downloadBlob(blob, `boleto-parcela-${installmentNumber ?? ''}.pdf`);
    },
  });
}
